import { UPLOAD_CARE_CANVAS_IMAGE } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    url?: string;
    error?: string;
}

export default (formData: FormData): Promise<Response> =>
    fetchWithRefresh(UPLOAD_CARE_CANVAS_IMAGE, {
        method: 'POST',
        body: formData,
    }).then((res) => res.json());
